export default __webpack_public_path__ + "media/images/users4-d9527be1d60fb0de17f090ea656fc8c2.png";